// Components/MainPage.jsx
import Home from "./Home";
import About from "./About";
import Services from "./Services";
import Team from "./Team";
import Project from "./Project";
import Contact from "./Contact";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
const MainPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100); // Slight delay ensures DOM is ready
      }
    }
  }, [location]);
  return (
    <>
      <Home />
      <About />
      <Services />
      <Team />
      <Project />
      <Contact />
    </>
  );
};

export default MainPage;
